import { signal, type Signal } from "~/sdk/signal";
import { useStore } from "@tanstack/react-store";

import Image from "~/components/ui/Image";
import { PROD_URL_HTTPS } from "~/utils/constants";
import { useEffect } from "react";
import { useUser } from "~/hooks/useUser";

export interface Props {
  translucentEffect?: boolean;
  isSearchVisible?: Signal<boolean>;
}

function MyAccount({ translucentEffect, isSearchVisible }: Props) {
  const searchVisibility = isSearchVisible ?? signal(false);
  const isSearchVisibleValue = useStore(searchVisibility.store, (s) => s);
  const { user } = useUser();
  const isUserLoggedIn = Boolean(user.value?.email);
  // URL de assets estáticos — nunca deriva de globalThis.location: isso causa
  // mismatch de hidratação (SSR não tem `location`, cai no fallback; o
  // cliente usa a origem real do navegador, divergindo do servidor).
  const host = PROD_URL_HTTPS;
  const userName = user?.value?.givenName;
  const emailUser = user?.value?.email;
  const validationName = userName ? userName : emailUser;

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.action === "redirect" && event.data?.url) {
        globalThis.location.href = event.data.url;
      }
    };

    globalThis.addEventListener("message", handleMessage);

    return () => {
      globalThis.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div className="flex items-center">
      <a
        href={isUserLoggedIn ? "/account" : "/login-user?returnUrl=%2Faccount"}
        aria-label={isUserLoggedIn ? "Minha conta" : "Log in"}
        className="flex items-center gap-2 lg:gap-2"
      >
        {/* <img> nativo, não o componente Image: proxy decoims.com está
            rejeitando (403) o domínio www.danielatombini.com.br como
            origem — provável allowlist de domínio não configurada pro
            site "dt" no admin da deco. Ver PLANO-REDESIGN.md. */}
        <img
          loading="lazy"
          className={`login-icon`}
          src={(
            translucentEffect
              ? `${host}/icon_my-account-new-white.png`
              : `${host}/icon_my-account-gray-new.png`
          )}
          alt="Minha conta"
          width={24}
          height={24}
        />
        <Image
          loading="lazy"
          className={`login-icon2 ${
            isSearchVisibleValue ? "visible-search" : ""
          }`}
          src={"https://decoims.com/danielatombini/ee239707-fbf9-4a85-bf5b-2f1be84e1237/60073b8b-d223-4b66-94fd-6d9ca01dceef___ed6759fc23daabc4979b411cf014028a.png"}
          alt="Minha conta"
          width={24}
          height={24}
        />
        <span className="user-name lg:hover:underline lg:max-w-35">
          {isUserLoggedIn
            ? (
              <div className="logged-user">
                <span className="user-name">Olá,</span>
                <span className="underline lg:no-underline user-name">
                  {validationName}
                </span>
              </div>
            )
            : (
              <div className="logged-out-user">
                <span className="underline lg:no-underline user-name">
                  Entrar
                </span>
              </div>
            )}
        </span>
      </a>
    </div>
  );
}

export default MyAccount;
